import { render, staticRenderFns } from "./dat-lich-tu-van.vue?vue&type=template&id=8c39e372"
import script from "./dat-lich-tu-van.vue?vue&type=script&lang=js"
export * from "./dat-lich-tu-van.vue?vue&type=script&lang=js"
import style0 from "./dat-lich-tu-van.vue?vue&type=style&index=0&id=8c39e372&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports